import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// Lazy load Bootstrap JS
const loadBootstrap = async () => {
  if (typeof window !== 'undefined') {
    await import('bootstrap/dist/js/bootstrap.bundle.min.js');
  }
};

// Load Bootstrap after initial render
setTimeout(loadBootstrap, 100);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </HelmetProvider>
  </StrictMode>
); 